module.exports = __webpack_public_path__ + "static/media/slider-box-opt.b89e265b.gif";